import { useEffect, useState } from 'react'

/**
 * Поле поиска, связанное с `q` в URL: ввод попадает в URL с задержкой (не дёргаем API на каждую
 * букву), а смена `q` не из поля («назад», ссылка) показывается в поле и не перетирается им.
 */
export function useUrlSearchText(
  q: string | undefined,
  setQ: (q: string | undefined) => void,
): [string, (text: string) => void] {
  const [text, setText] = useState(q ?? '')
  const [synced, setSynced] = useState(q ?? '')
  if ((q ?? '') !== synced) {
    setSynced(q ?? '')
    setText(q ?? '')
  }
  useEffect(() => {
    if ((q ?? '') === text) return
    const handle = setTimeout(() => {
      setSynced(text)
      setQ(text || undefined)
    }, 300)
    return () => clearTimeout(handle)
  }, [text, q, setQ])
  return [text, setText]
}
